import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

import { LinkButton } from './Chips';
import { canKeepMine, PendingOperation, slotOf, targetText } from './operations';

type Props = {
  op: PendingOperation | null | undefined;
  onKeepMine?: (op: PendingOperation) => void;
  onUndo?: (slot: string) => void;
};

export default function OperationProblem({ op, onKeepMine, onUndo }: Props) {
  if (!op?.conflict && !op?.error) return null;

  return (
    <Problem role='alert'>
      {op.conflict && (
        <>
          Changed by someone else: now {op.conflict.currentLabel ?? (targetText(op.conflict.current) || 'nothing')}.{' '}
          {onKeepMine && canKeepMine(op) && <LinkButton onClick={() => onKeepMine(op)}>Keep mine</LinkButton>}{' '}
          {onUndo && <LinkButton onClick={() => onUndo(slotOf(op))}>Take theirs</LinkButton>}
        </>
      )}
      {op.error && (
        <>
          {op.error} {onUndo && <LinkButton onClick={() => onUndo(slotOf(op))}>Undo</LinkButton>}
        </>
      )}
    </Problem>
  );
}

const Problem = styled.div`
  width: 100%;
  font-size: 12px;
  color: ${colors.red100};
`;
